import {} from "googlemaps";

export default class Popup extends google.maps.OverlayView {
	public position: google.maps.LatLng;
	public anchor: HTMLElement;
	public content: any;
	public clickEventHandler: any;

	// NOTE: google.maps.OverlayView is only defined once the Maps API has
	// loaded. That is why Popup is defined inside initMap().

	constructor(
		position: google.maps.LatLng,
		content: HTMLElement,
		clickEventHandler?: any
	) {
		super();

		this.position = position;
		this.clickEventHandler = clickEventHandler;
		this.content = content.cloneNode(true);

		this.content.classList.add("popup-bubble-content");

		const pixelOffset = document.createElement("div");
		pixelOffset.classList.add("popup-bubble-anchor");
		pixelOffset.appendChild(this.content);

		this.anchor = document.createElement("div");
		this.anchor.classList.add("popup-tip-anchor");
		this.anchor.appendChild(pixelOffset);

		// Optionally stop clicks, etc., from bubbling up to the map.
		this.stopEventPropagation();
		this.anchor.addEventListener("click", (e: any) => {
			this.clickEventHandler(e);
		});
	}

	/** Called when the popup is added to the map. */
	public onAdd() {
		this.getPanes().floatPane.appendChild(this.anchor);
	}

	/** Called when the popup is removed from the map. */
	public onRemove() {
		if (this.anchor.parentElement) {
			this.anchor.parentElement.removeChild(this.anchor);
		}
	}

	/** Called when the popup needs to draw itself. */
	public draw() {
		const divPosition = this.getProjection().fromLatLngToDivPixel(
			this.position
		);
		// Hide the popup when it is far out of view.
		const display =
			Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
				? "block"
				: "none";

		if (display === "block") {
			/* this.anchor.style.left = divPosition.x + 'px';
            this.anchor.style.top = divPosition.y + 'px'; */
			this.content.style.left = divPosition.x + "px";
			this.content.style.top = divPosition.y + "px";
		}
		if (this.anchor.style.display !== display) {
			this.anchor.style.display = display;
		}
	}

	/** Stops clicks/drags from bubbling up to the map. */
	private stopEventPropagation() {
		const anchor = this.anchor;
		anchor.style.cursor = "auto";

		[
			"click",
			"dblclick",
			"contextmenu",
			"wheel",
			"mousedown",
			"touchstart",
			"pointerdown"
		].forEach(event => {
			anchor.addEventListener(event, (e: any) => {
				e.stopPropagation();
			});
		});
	}
}
